module.exports = __webpack_public_path__ + "img/badge-fastest-lead-pickup-keyvue-blue.b1a45c46.png";